export const authStore = {
  state: {
    jwtTokenItem: {
      AccessToken: null,
      RefreshToken: null,
      jwtTokenExpires: null
    }
  },
  mutations: {
    setJWTTokenItem (state, payload) {
      state.jwtTokenItem.AccessToken = payload.jwtToken
      state.jwtTokenItem.RefreshToken = payload.refreshToken
      state.jwtTokenItem.jwtTokenExpires = payload.jwtTokenExpires
    },
    remJWTTokenItem (state) {
      state.jwtTokenItem.AccessToken = null
      state.jwtTokenItem.RefreshToken = null
      state.jwtTokenItem.jwtTokenExpires = null
    }
  },
  actions: {},
  getters: {
    getAccessToken (state) {
      return state.jwtTokenItem.AccessToken
    },
    getRefreshToken (state) {
      return state.jwtTokenItem.RefreshToken
    },
    getJWTokenExpires (state) {
      return state.jwtTokenItem.jwtTokenExpires
    }
  }
}
